import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.875 16.375C13.0171 16.375 16.375 13.0171 16.375 8.875C16.375 4.73286 13.0171 1.375 8.875 1.375C4.73286 1.375 1.375 4.73286 1.375 8.875C1.375 13.0171 4.73286 16.375 8.875 16.375Z",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.625 18.625L14.1782 14.1782",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
